const React = require('react');
const { createElement, forwardRef } = React;
const PropTypes = require('prop-types');

/**
 * Component that handles the rendering logic for loading, erroring, container embedding,
 * their defaults / customization capabilities
 */

const ModuleContainer = forwardRef(({
  containerId,
  style,
  className,
  error,
  errorComponent,
  loadingComponent,
  mainScriptId,
  appName,
  moduleProps,
}, ref) => {
  const getError = ({ error, component }) => component && component({ error, moduleProps }) || `Cannot load. ${error}`;

  const getLoading = ({ component }) => component ? component() : createElement('div', {
    className: 'remote-module__loading',
  }, createElement('div', {
    className: 'remote-module__loading-marker',
    'data-testid': 'remote-module-loading-marker',
  }));

  return createElement('section', {
    id: containerId,
    style,
    className,
    ref,
    'data-testid': 'remote-module-container',
    'data-script': mainScriptId,
    'data-app-name': appName,
  }, error ? getError({ error, component: errorComponent }) : getLoading({ component: loadingComponent }));
});

ModuleContainer.propTypes = {
  containerId: PropTypes.string.isRequired,
  style: PropTypes.shape(),
  className: PropTypes.string,
  error: PropTypes.string,
  loadingComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  errorComponent: PropTypes.oneOfType([PropTypes.element, PropTypes.elementType]),
  mainScriptId: PropTypes.string,
  appName: PropTypes.string,
};

ModuleContainer.defaultProps = {
  style: {},
  className: '',
  error: null,
  loadingComponent: null,
  errorComponent: null,
  mainScriptId: null,
  appName: 'default',
};

module.exports = ModuleContainer;
